import { Link } from 'react-router-dom';
import { siteInfo, navLinks } from '@/mocks/home';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-100">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-number-1 text-background-50 text-sm"></i>
                </div>
                <span className="font-heading text-lg font-semibold text-background-50">{siteInfo.name}</span>
              </div>
              <p className="text-sm text-background-300 leading-relaxed">
                {siteInfo.tagline}。收录海量番号信息，提供按类型、演员、厂牌等多维度分类检索服务。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">快速导航</h4>
              <ul className="space-y-2.5">
                {navLinks.map((link) => (
                  <li key={link.href}>
                    <Link to={link.href} className="text-sm text-background-300 hover:text-background-50 transition-colors cursor-pointer">
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">热门分类</h4>
              <ul className="space-y-2.5">
                <li><Link to="/category/actress" className="text-sm text-background-300 hover:text-background-50 transition-colors cursor-pointer">按演员查询</Link></li>
                <li><Link to="/category/label" className="text-sm text-background-300 hover:text-background-50 transition-colors cursor-pointer">按厂牌查询</Link></li>
                <li><Link to="/category/type" className="text-sm text-background-300 hover:text-background-50 transition-colors cursor-pointer">按类型查询</Link></li>
                <li><Link to="/category/series" className="text-sm text-background-300 hover:text-background-50 transition-colors cursor-pointer">按系列查询</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">关于我们</h4>
              <ul className="space-y-2.5">
                <li><Link to="/about" className="text-sm text-background-300 hover:text-background-50 transition-colors cursor-pointer">品牌介绍</Link></li>
                <li><Link to="/about" className="text-sm text-background-300 hover:text-background-50 transition-colors cursor-pointer">联系我们</Link></li>
                <li><span className="text-sm text-background-400">service@fanhao.example.com</span></li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-background-800">
        <div className="w-full px-4 md:px-6 py-5">
          <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-background-400">
              &copy; {new Date().getFullYear()} {siteInfo.name}. All rights reserved.
            </p>
            <div className="flex items-center gap-5">
              <span className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer">隐私政策</span>
              <span className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer">使用条款</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}